import React, { useState } from "react";
import EmailInput from "src/components/CreditRatingForm/EmailInput";
import CreditRatingTerms from "src/components/CreditRatingTerms";
import AddressInput from "./AddressInput";
import AreaInputs from "./AreaInputs";
import "./CreditRatingFormStyles.scss";
import { CRFClassNameGenerator as c } from "./CRF.utils";
import FormButtons from "./FormButtons";
import IncomeYearInputs from "./IncomeYearInputs";
import NameInputs from "./NameInputs";

export interface FormState {
    address: string;
    city: string;
    email: string;
    firstName: string;
    income: number;
    lastName: string;
    postal: string | null;
    state: string;
    year: string;
}

const initialState = {
    address: "",
    city: "",
    email: "",
    firstName: "",
    income: 0,
    lastName: "",
    postal: "",
    state: "",
    year: "",
};

const CreditRatingForm = ({
    cancelForm,
    initialFormData = initialState,
    isDrawer,
    submitForm,
}: {
    cancelForm: any;
    initialFormData?: Partial<FormState>;
    isDrawer: boolean;
    submitForm: any;
}) => {
    const [inputState, setInputState] = useState({ ...initialState, ...initialFormData });
    const handleIncomeUpdate = (income: number) => setInputState({ ...inputState, income });
    const handleUpdateState = (type: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setInputState({ ...inputState, [`${type}`]: event.target.value });
    };
    const handleSubmit = (submitEvent: React.FormEvent<HTMLFormElement>) => {
        submitEvent.preventDefault();
        submitForm(inputState);
    };
    const handleCancel = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setInputState({ ...initialState });
        cancelForm();
    };
    return (
        <form className={c(["", isDrawer ? "drawer" : "calculator"])} onSubmit={handleSubmit}>
            <NameInputs firstName={inputState.firstName} lastName={inputState.lastName} onChange={handleUpdateState} />
            <EmailInput email={inputState.email} onChange={handleUpdateState} />
            <AddressInput address={inputState.address} onChange={handleUpdateState} />
            <AreaInputs
                city={inputState.city}
                state={inputState.state}
                postal={inputState.postal}
                onChange={handleUpdateState}
            />
            <IncomeYearInputs
                income={inputState.income}
                handleIncomeUpdate={handleIncomeUpdate}
                onChange={handleUpdateState}
                year={inputState.year}
            />
            <FormButtons onCancel={handleCancel} />
            <CreditRatingTerms />
        </form>
    );
};

export default CreditRatingForm;
